// Design-theme control. The active theme is stored on <body data-theme> and
// persisted to localStorage. All token values live in theme.css.
export const THEMES = [
  { id: 'console', label: 'Console' },
  { id: 'terminal', label: 'Terminal' },
  { id: 'signature', label: 'Signature' },
]

const KEY = 'ats-theme'
const DEFAULT = 'console'

export const getTheme = () => {
  try {
    const t = localStorage.getItem(KEY)
    if (t && THEMES.some((x) => x.id === t)) return t
  } catch (e) { /* ignore */ }
  return DEFAULT
}

export const setTheme = (id) => {
  const t = THEMES.some((x) => x.id === id) ? id : DEFAULT
  document.body.setAttribute('data-theme', t)
  try { localStorage.setItem(KEY, t) } catch (e) { /* ignore */ }
  return t
}

// Called once at startup (index.js) so tokens resolve before first paint.
export const initTheme = () => setTheme(getTheme())
